export default __webpack_public_path__ + "static/media/logo-black.77876905.png";